// extracted by mini-css-extract-plugin
module.exports = {"field":"UsernameEditPopup_field__2TjeL","text":"UsernameEditPopup_text__1NwpJ"};